"use client";

import React from "react";
import { ArrowRight, MapPin } from "lucide-react";

/**
 * PagemakerInAllCantons — Section 5: Final CTA
 * Drop-in für: src/pages/PagemakerInAllCantons/sections/HeroIntroduction.tsx
 *
 * (Trotz Vibes Namen „HeroIntroduction" sitzt diese Sektion zuletzt vor
 * dem Footer — wir behandeln sie als finalen Page-CTA.)
 */

export default function HeroIntroduction() {
  return <section className="dark text-white relative w-full py-24 lg:py-32 overflow-hidden" style={{
    backgroundColor: "hsl(16,88%,54%)"
  }}>
      <div className="absolute inset-0 bg-gradient-to-br from-primary to-orange-600 shadow-[inset_0_0_60px_rgba(0,0,0,0.1)] z-0" />
      <div className="absolute inset-0 bg-white/5 z-0 pointer-events-none" />

      <div className="relative z-10 container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-3 py-1 text-xs font-medium text-white">
            <MapPin className="w-3 h-3" />
            26 Kantone · Eine Plattform · Schweizer Support
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white drop-shadow-md leading-tight">
            Bereit für Ihre Website — wo immer Sie in der Schweiz sind?
          </h2>
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto font-medium leading-relaxed">
            Egal ob Zürich, Lausanne oder Lugano — wir liefern Ihre
            professionelle KMU-Website in unter einer Stunde. Hosting in der
            Schweiz, Support auf Deutsch.
          </p>
          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="https://dashboard.pagemaker24.ch/sign-up" className="group inline-flex items-center justify-center gap-2 bg-white rounded-lg px-10 py-4 text-lg font-bold shadow-2xl transition-all duration-300 hover:bg-white/95 hover:scale-105" style={{
            color: "hsl(16,88%,54%)"
          }}>
              Kostenlos starten
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
            <p className="text-sm text-white/80">
              3 Tage gratis · Keine Kreditkarte
            </p>
          </div>
        </div>
      </div>
    </section>;
}